export default import.meta.ROLLDOWN_FILE_URL_fIdh2w8_0vgPq1hdHJ0xhw